const baseStyle = {}

const defaultProps = {}

const parts = ['container', 'backdrop', 'content']

const sizes = {}

const variants = {}

export default {
  baseStyle,
  defaultProps,
  parts,
  sizes,
  variants,
}
